module.exports = __webpack_public_path__ + "static/media/18.c349957a.png";